/**
 * Generates a type-safe shallow copy of the given source object whose type is the same as the source.
 * @param source The object to shallow copy.
 */
export const safeCopy = <TSource>(source: TSource) => {
  return Object.assign({}, source) as TSource;
};
